import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { getAdmRevenueComparison } from "../utils/revenueComparisionByYear"

export const queryAdmRevenueStatsComparison = {
  async admRevenueStatsComparison(parent, args, context, info) {
    const { admNumber, year } = args

    const { user } = context

    await checkPermissions({
      user,
      admNumber: admNumber,
      domainObject: DomainObjects.REVENUES,
      operation: Operations.READ,
    })

    const { currentYearRevenue, lastYearRevenue } = await getAdmRevenueComparison({
      year,
      admNumber,
    })

    return {
      admNumber,
      currentYearRevenue,
      lastYearRevenue,
    }
  },
}
